<template lang="pug">
div
  el-row.labelDiv
    el-col.inputDiv(:span="12")
      app-display(
        label="Denominação:",
        :content="getValue(imovel.denominacao)"
        :class = "copararImovelSolicitacao && copararImovelSolicitacao.mudouDenominacao ? 'text': '' "
      )
      app-display(
        label="Município:",
        :content="getMunicipio(imovel.municipio)",
        :class = "copararImovelSolicitacao && copararImovelSolicitacao.mudouMunicipio ? 'text': '' "
      )
      app-display(
        label="Área:",
        :content="area",
        :class = "copararImovelSolicitacao && copararImovelSolicitacao.mudouArea ? 'text': '' "
      )
    el-col.inputDiv(:span="12")
      app-display(
        label="Nome da colônia:",
        :content="getValue(imovel.nomeColonia)",
        :class = "copararImovelSolicitacao && copararImovelSolicitacao.mudouNomeColonia ? 'text': '' "
      )
      app-display(
        label="Localização:",
        :content="getValue(imovel.localizacao)",
        :class = "copararImovelSolicitacao && copararImovelSolicitacao.mudouLocalizacao ? 'text': '' "
      )
  info-matricula(:imovel="imovel")
  info-dados-titulo(:imovel="imovel")
</template>
<script>

import AppDisplay from '@/components/AppDisplay'
import utils from '@/utils/utils'
import InfoMatricula from '@/components/informacoesCadastro/common/InfoMatricula'
import InfoDadosTitulo from '@/components/informacoesCadastro/common/InfoDadosTitulo'

export default {
  components: {
    AppDisplay,
    InfoMatricula,
    InfoDadosTitulo
  },

  props: {
    imovel: {
      type: Object,
      required: true
    },
    copararImovelSolicitacao: {
      type: Object,
      required: true
    }
  },
  methods: {
    getValue (props) {
      return props || '-'
    },
    getMunicipio (municipio) {
      return municipio.municipioTitulo ? municipio.municipioTitulo.nome : (municipio.nome || '-')
    }
  },
  computed: {
    area () {
      if (this.imovel.area === 0) {
        return '-'
      }

      return utils.format(this.imovel.area, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 }) + ' hectare(s)'
    }
  }
}
</script>
<style lang="scss" scoped>
>>> .text .text{
    color: #ff0000 !important;
  }

  @media (max-width: 780px) {
    .labelDiv {
      display: flex;
      flex-direction: column;
    }

    .inputDiv {
      width: 85%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacoesImovelSolicitacao.vue